import { render, staticRenderFns } from "./TotalPay.vue?vue&type=template&id=12f804ac&"
import script from "./TotalPay.vue?vue&type=script&lang=js&"
export * from "./TotalPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports